import { Account } from "@idha/idha-types";
import { SELECTED_ACCOUNT } from "../actions-constants/selectedAccount.constants";

const initialSelectedAccount:Account = null;

export function selectedAccountReducer(selectedAccount:Account=initialSelectedAccount,action):Account {
    switch(action.type) {
        case SELECTED_ACCOUNT.SET_ACCOUNT:            
            return action.account ? {...action.account} : null;
        default:
            return selectedAccount
    }
}